import { Field } from '../declarations/widget-ums';

export type Error = string | boolean;
type State<T> = Record<string, Field<T>>;

export function createField<T = string>(value?: T): Field<T>;
export function createField(value: string = ''): Field<string> {
  return { value, disabled: false, error: false };
}

export function transformPayloadToField<T>(
  subfield: 'error',
  payload: { [P in keyof State<T>]?: Error },
  originalValues: State<T>
): Partial<State<T>>;
export function transformPayloadToField<T>(
  subfield: 'disabled',
  payload: { [P in keyof State<T>]?: boolean },
  originalValues: State<T>
): Partial<State<T>>;
export function transformPayloadToField<T>(
  subfield: 'value',
  payload: { [P in keyof State<T>]?: T },
  originalValues: State<T>
): Partial<State<T>>;
export function transformPayloadToField(subfield, payload, originalValues) {
  return Object.entries(payload).reduce((fields, [key, value]) => {
    fields[key] = { ...originalValues[key] };
    fields[key][subfield] = value;
    return fields;
  }, {});
}

export function getErrorPayload(payload) {
  return Object.keys(payload).reduce(
    (acc, key) => ({ ...acc, [key]: false }),
    {}
  );
}

export const getFIOPayload = (payload) => {
  const [key] = Object.keys(payload);
  return {
    [key]: { value: payload[key].value.trimLeft().replace(/^-*/, '') },
  };
};
